export default "__VITE_ASSET__K_DIts9e__"